import React from "react";
import { Divider } from "@qgiv/core-donor";
import { Icon } from "@qgiv/core-react";

/**
 * @param {object} props
 * @param {boolean} props.displayErrorStyling
 * @param {boolean} props.displayStatusIcon
 * @param {boolean} props.displayTopMargin
 * @param {boolean} props.displayTransactionIdLink
 * @param {string} props.formattedTextAfterTransactionId
 * @param {string} props.formattedTextBeforeTransactionId
 * @param {string} props.formattedTransactionAmount
 * @param {string} props.formattedTransactionDate
 * @param {Function} props.handleClick
 * @param {string} props.statusLabel
 * @param {string} props.transactionId
 * @param {string} props.transactionLinkUrl
 * @param {string} props.translatedStatus
 * @returns {React.JSX.Element}
 */
const RecurringSummaryHistoryListItem = ({
    displayErrorStyling,
    displayStatusIcon,
    displayTopMargin,
    displayTransactionIdLink,
    formattedTextAfterTransactionId,
    formattedTextBeforeTransactionId,
    formattedTransactionAmount,
    formattedTransactionDate,
    handleClick,
    statusLabel,
    transactionId,
    transactionLinkUrl,
    translatedStatus,
}) => (
    <>
        <div
            className={`qg-vendor-recurring-summary-history-item recurring-summary-history-item ${displayTopMargin ? "-margin-top--10" : ""}`}
        >
            <p className="qg-vendor-recurring-summary-history-transaction">
                {formattedTextBeforeTransactionId}
                {/* When a receipt ID exists we provide a link to the confirmation page. 
                            Otherwise display the transaction ID as plain text */}
                {displayTransactionIdLink ? (
                    <a
                        href={transactionLinkUrl}
                        target="_blank"
                        rel="noreferrer"
                        onClick={handleClick}
                    >
                        <strong>{` #${transactionId}`}</strong>
                    </a>
                ) : (
                    <span>#{transactionId}</span>
                )}
                {formattedTextAfterTransactionId}
            </p>
            <span
                className={`${displayErrorStyling ? "recurring-transaction-failure" : ""}`}
            >
                {formattedTransactionAmount}
            </span>
        </div>
        <p className="qg-vendor-recurring-summary-history-status">
            {statusLabel}:
            <span
                className={`-margin-left--5 ${
                    displayErrorStyling
                        ? "recurring-payment-status-icon--error"
                        : ""
                } ${displayStatusIcon ? "recurring-payment-status-icon" : ""}`}
            >
                {displayStatusIcon && (
                    <Icon glyph="exclamation-circle-solid" type="FontAwesome" />
                )}{" "}
                {translatedStatus}
            </span>
        </p>
        <br />
        <p className="qg-vendor-recurring-summary-history-date">
            {formattedTransactionDate}
        </p>
        <Divider dashed />
    </>
);

export default RecurringSummaryHistoryListItem;
